import React from "react";
import { Link } from "react-router-dom";
import {
  ArrowRight,
  BrainCircuit,
  CloudCog,
  Boxes,
  Rocket,
  Cloud,
  Workflow,
  Container,
  Activity,
  Network,
  GitGraph,
  Globe2,
  Crown,
  Wrench,
  Server,
  CheckCircle2,
} from "lucide-react";

export const iconMap = {
  BrainCircuit,
  CloudCog,
  Boxes,
  Rocket,
  Cloud,
  Workflow,
  Container,
  Activity,
  Network,
  GitGraph,
  Globe2,
  Crown,
  Wrench,
  Server,
};

export function Icon({ name, className = "w-5 h-5" }) {
  const C = iconMap[name] || Cloud;
  return <C className={className} />;
}

export function SectionLoader() {
  return (
    <div className="max-w-[1280px] mx-auto px-6 lg:px-10 py-32">
      <div className="animate-pulse space-y-6">
        <div className="h-8 w-40 bg-[#D9E0F0] rounded-full" />
        <div className="h-14 w-2/3 bg-[#D9E0F0] rounded-lg" />
        <div className="h-6 w-1/2 bg-[#D9E0F0] rounded" />
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mt-8">
          {[0, 1, 2].map((i) => (
            <div key={i} className="h-48 bg-[#D9E0F0] rounded-3xl" />
          ))}
        </div>
      </div>
    </div>
  );
}

export function BackLink({ to = "/", label = "Back" }) {
  return (
    <Link
      to={to}
      className="inline-flex items-center gap-2 text-sm font-semibold text-[#0A1F47]/70 hover:text-[#2E6BF6] transition-colors"
    >
      <ArrowRight className="w-4 h-4 rotate-180" /> {label}
    </Link>
  );
}

export function Bullets({ items }) {
  return (
    <ul className="space-y-2.5">
      {items.map((it) => (
        <li key={it} className="flex items-start gap-3 text-sm text-[#0A1F47]/80">
          <CheckCircle2 className="w-[18px] h-[18px] text-[#2E6BF6] mt-0.5 flex-shrink-0" />
          <span>{it}</span>
        </li>
      ))}
    </ul>
  );
}
